
<script>
export default {
  name: 'DatesRangeField',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    min: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    menu: false,
    dates: []
  }),
  computed: {
    dateRangeText () {
      return this.dates.map(date => this.$options.filters.date(date)).join(' ~ ');
    },
    minDate () {
      if (this.dates.length === 1) {
        return this.dates[0];
      }
      return this.min;
    }
  },
  watch: {
    value (val) {
      this.dates = val || [];
    }
  },
  created () {
    this.dates = this.value || [];
  },
  methods: {
    clearValue () {
      this.dates = [];
      this.$emit('input', []);
    },
    cancel () {
      this.dates = this.value || [];
      this.menu = false;
    },
    submit () {
      this.$emit('input', this.dates);
      this.menu = false;
    }
  }
};
</script>

<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateRangeText"
        :label="label"
        prepend-icon="mdi-calendar"
        readonly
        :rules="rules"
        v-on="on"
      >
        <template v-slot:append>
          <v-icon @click="clearValue()">
            mdi-close
          </v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="dates"
      no-title
      range
      :min="minDate"
    >
      <v-spacer />
      <v-btn
        @click="cancel()"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :disabled="dates.length !== 2"
        @click="submit()"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>
